// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.chat-bot{
	position: fixed;
    right: 0;
    bottom: 0;
    width: 80px;
    height: 80px;
    background-color: var(--accent-color);
    margin: 20px;
    border-radius: 15px;
    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));
    cursor: pointer;
}

.dashboard-modal-dialog .dashboard-modal-dialog-titlebar {
    background: var(--accent-color) !important;
    border: none;
    padding: 5px 10px;
}

.dashboard-modal-dialog .dashboard-modal-dialog-titlebar .ui-dialog-title {
    color: #fff;
    font-size: 13px;
}

.dashboard-modal-dialog .dashboard-modal-dialog-titlebar .ui-button {
    color: #fff;
}

.chat-bot-modal-content{
    margin: 0;
    padding: 0 10px 10px 10px !important;
    display: flex;
    flex-direction: column;
    height: 100%;
    box-sizing: border-box;
    overflow: hidden !important;
}

.ai-chat{
    flex: 1;
    overflow-y: auto;
    overflow-x: hidden;
    margin-top: 10px;
    scroll-behavior: smooth;
    scrollbar-width: thin;
    scrollbar-color: rgba(0,0,0,0.15) transparent;
    position: relative;
    -webkit-user-select: text;
    -moz-user-select: text;
    -ms-user-select: text;
    user-select: text;
}

.ai-chat::-webkit-scrollbar {
    width: 5px;
}

.ai-chat::-webkit-scrollbar-track {
    background: transparent;
}

.ai-chat::-webkit-scrollbar-thumb {
    background: rgba(0,0,0,0.15);
    border-radius: 10px;
}

.ai-chat::-webkit-scrollbar-thumb:hover {
    background: rgba(0,0,0,0.3);
}

.search-area{
    flex-shrink: 0;
}

#messageCounter{
    flex-shrink: 0;
    margin: 10px 10px 0;
    text-align: center;
    font-size: 11px;
}

.message-box{
    padding: 10px 12px;
    border-radius: 0 6px 6px 6px;
    position: relative;
    background: rgba(171, 207, 57, 0.025);
    border: 2px solid var(--main-secondary);
    color: #2d2d2d;
    font-size: 12px;
    margin: 0;
    box-sizing: border-box;
    word-wrap: break-word;
    overflow-wrap: break-word;
}

.message-box p{
    margin: 0;
}

.message-box li{
    margin-left: 16px;
    list-style: disc;
    line-height: 1.6;
}

.message-box strong{
    font-weight: 600;
}

.message-box em{
    font-style: italic;
}

.time{
    font-size: 10px;
    text-align: right;
}

.ai-response{
    display: flex;
    align-items: flex-start;
    gap: 8px;
    margin-bottom: 15px;
}


  .ask {
    background: rgba(248,155,60,0.02);
    border: var(--accent-color) 2px solid;
    border-radius: 6px 0 6px 6px;
    box-sizing: border-box;
    flex: 1;
    min-width: 0;
  }
  
  

.ai-response .ai-img{
    flex-shrink: 0;
    margin-top: 4px;
}

.ai-response-content{
    flex: 1;
    min-width: 0;
}

.ai-ask{
    display: flex;
    align-items: flex-start;
    flex-direction: row-reverse;
    gap: 8px;
    margin-bottom: 15px;
}

.user-avatar{
    flex-shrink: 0;
    width: 36px;
    height: 36px;
    border-radius: 50%;
    background: linear-gradient(135deg, var(--accent-color), #e8873a);
    color: #fff;
    font-size: 13px;
    font-weight: 600;
    display: flex;
    align-items: center;
    justify-content: center;
    letter-spacing: 0.5px;
    margin-top: 4px;
    box-shadow: 0 2px 4px rgba(0,0,0,0.15);
}

/* Styling the input field */
.input-group {
    margin-top: 20px;
    background-color: #fff;
    display: flex;
    flex-direction: column;
    flex-shrink: 0;
}
.ai-form-control {
    border: #ACACAC solid 1px !important;
    border-radius: 7px 7px 0 0 !important;
    border-bottom: none !important;
    display: block;
    min-height: 35px;
    max-height: 120px;
    padding: 0.375rem 0.75rem;
    font-size: 12px !important;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    resize: none;
    overflow-y: auto;
    font-family: inherit;
    width: 100%;
    box-sizing: border-box;
}
.input-toolbar {
    display: flex;
    align-items: center;
    justify-content: flex-end;
    gap: 4px;
    padding: 4px 8px;
    border: #ACACAC solid 1px;
    border-top: none;
    border-radius: 0 0 7px 7px;
    background: #fafafa;
}
.toolbar-btn {
    font-size: 14px;
    color: #888;
    cursor: pointer;
    padding: 4px 6px;
    border-radius: 4px;
    transition: all 0.15s;
}
.toolbar-btn:hover {
    color: var(--accent-color);
    background: rgba(248,155,60,0.08);
}

/* File chip */
.ai-file-chip-area {
    flex-shrink: 0;
}
.ai-file-chip {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 5px 10px;
    margin: 6px 0 0;
    background: #f0f4f8;
    border: 1px solid #d0d7de;
    border-radius: 6px;
    font-size: 11px;
    color: #333;
}
.file-chip-name {
    font-weight: 600;
    max-width: 180px;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
}
.file-chip-size {
    color: #888;
}
.file-chip-remove {
    cursor: pointer;
    color: #888;
    margin-left: auto;
    font-size: 10px;
}
.file-chip-remove:hover {
    color: #d32f2f;
}

/* Drag-drop overlay */
.ai-drop-overlay {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(248,155,60,0.08);
    border: 2px dashed var(--accent-color);
    border-radius: 8px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-size: 13px;
    color: var(--accent-color);
    font-weight: 600;
    z-index: 10;
    pointer-events: none;
}

/* File indicator in user message */
.ai-file-indicator {
    display: inline-flex;
    align-items: center;
    gap: 4px;
    background: #e8f0fe;
    padding: 2px 8px;
    border-radius: 4px;
    font-size: 10px;
    color: #1a73e8;
    margin-bottom: 4px;
}
.ai-file-indicator .glyphicon {
    font-size: 10px;
}


.ai-sources{
    font-size: 10px;
    font-weight: bold;
    margin: 20px 0;
    background-color: #EDEDED;
    padding: 10px;
    border-radius: 6px;
    line-height: 20px;
    overflow: hidden;
    word-break: break-all;
}

.ai-sources a{
    font-weight: normal;
    word-break: break-all;
    display: inline-block;
    max-width: 100%;
}

/* Message action buttons */
.msg-actions {
    display: flex;
    gap: 4px;
    margin-top: 8px;
    padding-top: 6px;
    border-top: 1px solid rgba(0, 0, 0, 0.06);
}

.msg-action-btn {
    background: none;
    border: 1px solid transparent;
    border-radius: 4px;
    padding: 2px 5px;
    cursor: pointer;
    color: #999;
    font-size: 11px;
    transition: all 0.15s ease;
}

.msg-action-btn:hover {
    color: #555;
    background: rgba(0, 0, 0, 0.05);
    border-color: rgba(0, 0, 0, 0.1);
}

.msg-action-btn.active {
    color: var(--accent-color);
}

.msg-action-btn.active .glyphicon-thumbs-up,
.msg-action-btn.active .glyphicon-thumbs-down {
    color: var(--accent-color);
}

.msg-action-btn.active .glyphicon-copy {
    color: var(--main-primary);
}

/* Status text while searching/generating */
.ai-status-text {
    font-size: 11px;
    color: #888;
    padding: 6px 0;
    font-style: italic;
}

.ai-status-text .status-icon {
    color: var(--accent-color);
    animation: status-pulse 1.2s infinite;
    display: inline-block;
    font-size: 10px;
    vertical-align: middle;
    margin-right: 4px;
}

.ai-status-text .status-icon.done {
    animation: none;
    color: #4CAF50;
    font-size: 14px;
}

.dot-anim::after {
    content: '';
    animation: dot-loading 1.5s infinite;
}

@keyframes dot-loading {
    0% { content: ''; }
    25% { content: '.'; }
    50% { content: '..'; }
    75% { content: '...'; }
}

@keyframes status-pulse {
    0%, 100% { opacity: 0.3; }
    50% { opacity: 1; }
}

.dot-pulse {
    position: relative;
    left: -9999px;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: var(--main-secondary);
    color: var(--main-secondary);
    box-shadow: 9999px 0 0 -5px;
    animation: dot-pulse 1.5s infinite linear;
    animation-delay: 0.25s;
    margin-left: 95px;
  }
  .dot-pulse::before, .dot-pulse::after {
    content: "";
    display: inline-block;
    position: absolute;
    top: 0;
    width: 10px;
    height: 10px;
    border-radius: 5px;
    background-color: var(--main-secondary);
    color: var(--main-secondary);
  }
  .dot-pulse::before {
    box-shadow: 9984px 0 0 -5px;
    animation: dot-pulse-before 1.5s infinite linear;
    animation-delay: 0s;
  }
  .dot-pulse::after {
    box-shadow: 10014px 0 0 -5px;
    animation: dot-pulse-after 1.5s infinite linear;
    animation-delay: 0.5s;
  }
  
  @keyframes dot-pulse-before {
    0% {
      box-shadow: 9984px 0 0 -5px;
    }
    30% {
      box-shadow: 9984px 0 0 2px;
    }
    60%, 100% {
      box-shadow: 9984px 0 0 -5px;
    }
  }
  @keyframes dot-pulse {
    0% {
      box-shadow: 9999px 0 0 -5px;
    }
    30% {
      box-shadow: 9999px 0 0 2px;
    }
    60%, 100% {
      box-shadow: 9999px 0 0 -5px;
    }
  }
  @keyframes dot-pulse-after {
    0% {
      box-shadow: 10014px 0 0 -5px;
    }
    30% {
      box-shadow: 10014px 0 0 2px;
    }
    60%, 100% {
      box-shadow: 10014px 0 0 -5px;
    }
  }

/* Connection Proposal Card */
.ai-connection-proposal {
    margin: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.proposal-header {
    background: var(--accent-color);
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.proposal-header .proposal-icon {
    font-size: 13px;
}

.proposal-details {
    padding: 10px 12px 6px;
    font-size: 11px;
    line-height: 1.6;
}

.proposal-field {
    margin-bottom: 2px;
}

.proposal-label {
    font-weight: 600;
    color: #555;
}

.proposal-url {
    color: var(--accent-color);
    word-break: break-all;
}

.proposal-desc {
    color: #777;
    font-style: italic;
    margin-top: 4px;
}

.proposal-endpoints {
    padding: 6px 12px 10px;
    font-size: 11px;
}

.proposal-endpoints-title {
    font-weight: 600;
    color: #555;
    margin-bottom: 4px;
}

.proposal-action-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 0;
    border-bottom: 1px solid #f0f0f0;
}

.proposal-action-item:last-child {
    border-bottom: none;
}

.proposal-method {
    background: #e8f5e9;
    color: #2e7d32;
    font-size: 9px;
    font-weight: 700;
    padding: 1px 5px;
    border-radius: 3px;
    min-width: 32px;
    text-align: center;
}

.proposal-operation {
    font-size: 11px;
    font-weight: 600;
    color: #333;
    flex: 1;
}

.proposal-action-type {
    background: #e3f2fd;
    color: #1565c0;
    font-size: 8px;
    font-weight: 700;
    padding: 1px 4px;
    border-radius: 3px;
    min-width: 40px;
    text-align: center;
    letter-spacing: 0.3px;
}

.proposal-db-type {
    font-weight: 600;
    color: #1565c0;
}

.proposal-no-actions {
    padding: 8px 0;
    font-size: 11px;
    color: #888;
    font-style: italic;
}

.proposal-endpoint {
    flex: 1;
    font-family: monospace;
    font-size: 11px;
    color: #333;
}

.proposal-param-count {
    color: #999;
    font-size: 10px;
    white-space: nowrap;
}

.proposal-buttons {
    padding: 8px 12px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e0e0e0;
    background: #f5f5f5;
}

.proposal-btn {
    padding: 6px 14px;
    border-radius: 4px;
    font-size: 11px;
    font-weight: 600;
    cursor: pointer;
    border: none;
    transition: all 0.15s ease;
}

.proposal-btn-create {
    background: var(--accent-color);
    color: #fff;
}

.proposal-btn-create:hover {
    opacity: 0.9;
}

.proposal-btn-create:disabled {
    opacity: 0.6;
    cursor: not-allowed;
}

.proposal-btn-cancel {
    background: #fff;
    color: #666;
    border: 1px solid #ddd;
}

.proposal-btn-cancel:hover {
    background: #f0f0f0;
}

/* Connection Fallback Card */
.ai-connection-fallback {
    margin: 10px 0;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.fallback-header {
    background: #607D8B;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.fallback-body {
    padding: 10px 12px;
    font-size: 11px;
    line-height: 1.5;
}

.fallback-body > p {
    margin: 0 0 10px;
    color: #555;
}

.fallback-options {
    display: flex;
    flex-direction: column;
    gap: 6px;
}

.fallback-option {
    display: flex;
    align-items: flex-start;
    gap: 10px;
    padding: 8px 10px;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    background: #fff;
}

.fallback-option:hover {
    border-color: var(--accent-color);
    background: rgba(248,155,60,0.03);
}

.fallback-option .glyphicon {
    font-size: 16px;
    color: var(--accent-color);
    margin-top: 2px;
    flex-shrink: 0;
}

.fallback-option strong {
    font-size: 11px;
    color: #333;
    display: block;
    margin-bottom: 2px;
}

.fallback-option p {
    margin: 0;
    color: #888;
    font-size: 10px;
    line-height: 1.4;
}

.fallback-switch {
    margin-top: 10px;
    padding-top: 8px;
    border-top: 1px solid #e8e8e8;
    text-align: center;
}
.fallback-switch-link {
    font-size: 11px;
    color: var(--accent-color);
    cursor: pointer;
    text-decoration: underline;
}
.fallback-switch-link:hover {
    color: #d47a1a;
}

/* Connection Type Chooser */
.ai-connection-type-chooser {
    margin: 10px 0;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.type-chooser-header {
    background: var(--accent-color);
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.type-chooser-body {
    padding: 10px 12px;
}

.connection-type-options {
    display: grid;
    grid-template-columns: 1fr 1fr;
    gap: 6px;
}

.connection-type-option {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    padding: 8px 10px;
    border: 1px solid #e8e8e8;
    border-radius: 6px;
    cursor: pointer;
    transition: all 0.15s ease;
    background: #fff;
}

.connection-type-option:hover {
    border-color: var(--accent-color);
    background: rgba(248,155,60,0.03);
}

.connection-type-option .glyphicon {
    font-size: 14px;
    color: var(--accent-color);
    margin-top: 2px;
    flex-shrink: 0;
}

.connection-type-option strong {
    font-size: 11px;
    color: #333;
    display: block;
    margin-bottom: 1px;
}

.connection-type-option p {
    margin: 0;
    color: #888;
    font-size: 10px;
    line-height: 1.3;
}

/* Test Connection Card */
.ai-test-connection-card {
    margin: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.test-card-header {
    background: #1976D2;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.test-card-body {
    padding: 10px 12px;
    font-size: 11px;
    color: #555;
    line-height: 1.5;
}

.test-card-body p {
    margin: 0;
}

.test-card-buttons {
    padding: 8px 12px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e0e0e0;
    background: #f5f5f5;
}

/* Credential Form */
.ai-credential-form {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    background: #fafafa;
    margin: 8px 0;
}
.cred-form-header {
    background: #6A1B9A;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}
.cred-form-body {
    padding: 10px 12px;
    display: flex;
    flex-direction: column;
    gap: 8px;
}
.cred-form-field {
    display: flex;
    flex-direction: column;
    gap: 3px;
}
.cred-form-label {
    font-size: 11px;
    font-weight: 600;
    color: #555;
}
.cred-form-input {
    border: 1px solid #ccc;
    border-radius: 4px;
    padding: 6px 8px;
    font-size: 12px;
    font-family: inherit;
    outline: none;
}
.cred-form-input:focus {
    border-color: var(--accent-color);
    box-shadow: 0 0 0 2px rgba(var(--accent-color-rgb, 232, 151, 39), 0.15);
}
.cred-form-buttons {
    padding: 8px 12px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e0e0e0;
    background: #f5f5f5;
}

/* Update Warning */
.proposal-update-warning {
    padding: 8px 12px;
    margin: 0;
    background: #fff8e1;
    border-top: 1px solid #ffe082;
    color: #e65100;
    font-size: 12px;
    line-height: 1.4;
}

.proposal-update-warning .glyphicon {
    margin-right: 5px;
}

/* Markdown Tables */
.ai-md-table {
    border-collapse: collapse;
    width: 100%;
    margin: 8px 0;
    font-size: 12px;
}

.ai-md-table th,
.ai-md-table td {
    border: 1px solid #ddd;
    padding: 5px 8px;
    text-align: left;
}

.ai-md-table th {
    background: #f5f5f5;
    font-weight: 600;
}

.ai-md-table tr:nth-child(even) {
    background: #fafafa;
}

/* AutoComplete Results */
.ai-autocomplete-results {
    margin-top: 8px;
    padding-top: 8px;
    border-top: 1px solid #e0e0e0;
    font-size: 12px;
}

.autocomplete-result-row {
    padding: 3px 0;
}

.autocomplete-result-row.success {
    color: #27ae60;
}

.autocomplete-result-row.error {
    color: #e74c3c;
}

.autocomplete-icon {
    font-weight: bold;
    margin-right: 4px;
}

/* Test Results */
.ai-test-results {
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    overflow: hidden;
    background: #fafafa;
}

.test-results-header {
    background: #388E3C;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.test-results-body {
    padding: 8px 12px;
}

.test-result-row {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 5px 0;
    border-bottom: 1px solid #f0f0f0;
    font-size: 11px;
}

.test-result-row:last-child {
    border-bottom: none;
}

.test-result-icon {
    font-size: 13px;
    width: 18px;
    text-align: center;
    flex-shrink: 0;
}

.test-passed .test-result-icon {
    color: #2e7d32;
}

.test-fixed .test-result-icon {
    color: #F57C00;
}

.test-failed .test-result-icon {
    color: #c62828;
}

.test-result-name {
    flex: 1;
    color: #333;
    font-weight: 500;
}

.test-result-status {
    font-size: 10px;
    font-weight: 600;
    text-transform: uppercase;
    padding: 1px 6px;
    border-radius: 3px;
}

.test-passed .test-result-status {
    background: #e8f5e9;
    color: #2e7d32;
}

.test-fixed .test-result-status {
    background: #FFF3E0;
    color: #E65100;
}

.test-failed .test-result-status {
    background: #FFEBEE;
    color: #c62828;
}

.test-fix-details {
    font-size: 10px;
    color: #888;
    font-style: italic;
}

.test-results-summary {
    padding: 8px 12px;
    border-top: 1px solid #e0e0e0;
    background: #f5f5f5;
    font-size: 11px;
    display: flex;
    gap: 8px;
    align-items: center;
}

.test-summary-stats {
    font-weight: 600;
    color: #555;
}

.test-summary-text {
    color: #777;
}

/* Parameter Reference Card */
.ai-param-reference {
    margin: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.param-ref-header {
    background: #455A64;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.param-ref-body {
    padding: 8px 12px;
}

.param-ref-action {
    margin-bottom: 10px;
    border-bottom: 1px solid #e8e8e8;
    padding-bottom: 8px;
}

.param-ref-action:last-child {
    margin-bottom: 0;
    border-bottom: none;
    padding-bottom: 0;
}

.param-ref-action-header {
    display: flex;
    align-items: center;
    gap: 6px;
    margin-bottom: 6px;
    font-size: 11px;
}

.param-ref-action-header strong {
    color: #333;
}

.param-ref-endpoint {
    font-family: monospace;
    font-size: 10px;
    color: #888;
}

.param-ref-section {
    margin-left: 4px;
    margin-bottom: 4px;
}

.param-ref-section-title {
    font-size: 10px;
    font-weight: 600;
    color: #777;
    margin-bottom: 2px;
}

.param-ref-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 2px 0 2px 8px;
    font-size: 10px;
    border-left: 2px solid #e0e0e0;
    margin-bottom: 1px;
}

.param-ref-name {
    font-weight: 600;
    color: #333;
    font-family: monospace;
    font-size: 10px;
}

.param-ref-type {
    background: #ECEFF1;
    color: #546E7A;
    font-size: 9px;
    padding: 0 4px;
    border-radius: 2px;
    font-family: monospace;
}

.param-ref-placement {
    background: #E8EAF6;
    color: #3F51B5;
    font-size: 9px;
    padding: 0 4px;
    border-radius: 2px;
}

.param-ref-desc {
    color: #999;
    font-size: 9px;
    font-style: italic;
    flex: 1;
}

/* ========================================
   Vector Database Connection Components
   ======================================== */

/* Vector DB Credentials Form */
.ai-vectordb-form .cred-form-header.vectordb-header {
    background: #009688;
}

.ai-vectordb-form .proposal-btn-create {
    background: #009688;
}

.ai-vectordb-form .proposal-btn-create:hover {
    background: #00796B;
}

/* Vector DB Proposal Card - teal header */
.ai-connection-proposal .proposal-header:has(.glyphicon-grain) {
    background: #009688;
}

/* Vector DB action type badge */
.vectordb-action-type {
    background: #E0F2F1 !important;
    color: #00695C !important;
    border: 1px solid #B2DFDB;
}

/* Linked Apps in Proposal */
.vectordb-linked-apps {
    margin-top: 6px;
    padding-top: 6px;
    border-top: 1px solid #e8e8e8;
}

.vectordb-linked-app-item {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 0;
    font-size: 11px;
    color: #333;
}

.vectordb-linked-app-item .glyphicon {
    color: #009688;
    font-size: 11px;
}

.vectordb-live-sync-badge {
    background: #E8F5E9;
    color: #2E7D32;
    font-size: 9px;
    padding: 1px 6px;
    border-radius: 3px;
    margin-left: auto;
}

/* App Selector Card */
.ai-app-selector-card {
    margin: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.app-selector-header {
    background: #009688;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.app-selector-body {
    padding: 10px 12px;
}

.app-selector-desc {
    font-size: 11px;
    color: #666;
    margin: 0 0 8px 0;
}

.app-selector-list {
    max-height: 200px;
    overflow-y: auto;
    border: 1px solid #e8e8e8;
    border-radius: 4px;
    background: #fff;
}

.app-selector-item {
    display: flex;
    align-items: center;
    gap: 8px;
    padding: 6px 10px;
    cursor: pointer;
    font-size: 11px;
    border-bottom: 1px solid #f0f0f0;
    margin: 0;
    font-weight: normal;
}

.app-selector-item:last-child {
    border-bottom: none;
}

.app-selector-item:hover {
    background: #f5f5f5;
}

.app-selector-checkbox {
    margin: 0;
    flex-shrink: 0;
}

.app-selector-name {
    flex: 1;
    color: #333;
}

.app-selector-count {
    color: #999;
    font-size: 10px;
}

.app-selector-toggle {
    margin-top: 6px;
    text-align: right;
}

.app-selector-toggle a {
    font-size: 10px;
    color: #009688;
    text-decoration: none;
}

.app-selector-toggle a:hover {
    text-decoration: underline;
}

.app-selector-buttons {
    padding: 8px 12px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e8e8e8;
}

.app-selector-buttons .proposal-btn-create {
    background: #009688;
}

.app-selector-buttons .proposal-btn-create:hover {
    background: #00796B;
}

/* Sync Prompt Card */
.ai-sync-prompt-card {
    margin: 10px 12px;
    border: 1px solid #e0e0e0;
    border-radius: 8px;
    background: #fafafa;
    overflow: hidden;
}

.sync-prompt-header {
    background: #2E7D32;
    color: #fff;
    padding: 8px 12px;
    font-size: 12px;
    display: flex;
    align-items: center;
    gap: 6px;
}

.sync-prompt-body {
    padding: 10px 12px;
    font-size: 11px;
}

.sync-prompt-body p {
    margin: 0 0 8px 0;
    color: #555;
}

.sync-app-row {
    display: flex;
    align-items: center;
    gap: 6px;
    padding: 3px 0;
    color: #333;
    font-size: 11px;
}

.sync-app-row .glyphicon {
    color: #009688;
    font-size: 11px;
}

.sync-prompt-buttons {
    padding: 8px 12px;
    display: flex;
    gap: 8px;
    border-top: 1px solid #e8e8e8;
}

.sync-prompt-buttons .proposal-btn-create {
    background: #009688;
}

.sync-prompt-buttons .proposal-btn-create:hover {
    background: #00796B;
}

/* Vector DB type option in chooser - teal accent */
.connection-type-option[data-connection-type="vectordb"] .glyphicon {
    color: #009688;
}

.connection-type-option[data-connection-type="vectordb"]:hover {
    border-color: #009688;
    background: rgba(0,150,136,0.03);
}`, "",{"version":3,"sources":["webpack://./assets/style/chat-bot.css"],"names":[],"mappings":"AAAA;CACC,eAAe;IACZ,QAAQ;IACR,SAAS;IACT,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,YAAY;IACZ,mBAAmB;IACnB,oDAAoD;IACpD,eAAe;AACnB;;AAEA;IACI,0CAA0C;IAC1C,YAAY;IACZ,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,SAAS;IACT,oCAAoC;IACpC,aAAa;IACb,sBAAsB;IACtB,YAAY;IACZ,sBAAsB;IACtB,2BAA2B;AAC/B;;AAEA;IACI,OAAO;IACP,gBAAgB;IAChB,kBAAkB;IAClB,gBAAgB;IAChB,uBAAuB;IACvB,qBAAqB;IACrB,6CAA6C;IAC7C,kBAAkB;IAClB,yBAAyB;IACzB,sBAAsB;IACtB,qBAAqB;IACrB,iBAAiB;AACrB;;AAEA;IACI,UAAU;AACd;;AAEA;IACI,uBAAuB;AAC3B;;AAEA;IACI,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,2BAA2B;AAC/B;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,mBAAmB;IACnB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,kBAAkB;IAClB,4BAA4B;IAC5B,kBAAkB;IAClB,qCAAqC;IACrC,uCAAuC;IACvC,cAAc;IACd,eAAe;IACf,SAAS;IACT,sBAAsB;IACtB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,mBAAmB;AACvB;;;EAGE;IACE,iCAAiC;IACjC,qCAAqC;IACrC,4BAA4B;IAC5B,sBAAsB;IACtB,OAAO;IACP,YAAY;EACd;;;;AAIF;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,OAAO;IACP,YAAY;AAChB;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,2BAA2B;IAC3B,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,cAAc;IACd,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iEAAiE;IACjE,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qBAAqB;IACrB,eAAe;IACf,sCAAsC;AAC1C;;AAEA,4BAA4B;AAC5B;IACI,gBAAgB;IAChB,sBAAsB;IACtB,aAAa;IACb,sBAAsB;IACtB,cAAc;AAClB;AACA;IACI,oCAAoC;IACpC,qCAAqC;IACrC,8BAA8B;IAC9B,cAAc;IACd,gBAAgB;IAChB,iBAAiB;IACjB,yBAAyB;IACzB,0BAA0B;IAC1B,gBAAgB;IAChB,cAAc;IACd,sBAAsB;IACtB,4BAA4B;IAC5B,YAAY;IACZ,gBAAgB;IAChB,oBAAoB;IACpB,WAAW;IACX,sBAAsB;AAC1B;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,yBAAyB;IACzB,QAAQ;IACR,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,0BAA0B;IAC1B,mBAAmB;AACvB;AACA;IACI,eAAe;IACf,WAAW;IACX,eAAe;IACf,gBAAgB;IAChB,kBAAkB;IAClB,qBAAqB;AACzB;AACA;IACI,0BAA0B;IAC1B,iCAAiC;AACrC;;AAEA,cAAc;AACd;IACI,cAAc;AAClB;AACA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,mBAAmB;IACnB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,WAAW;AACf;AACA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,gBAAgB;IAChB,uBAAuB;IACvB,mBAAmB;AACvB;AACA;IACI,WAAW;AACf;AACA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;IACjB,eAAe;AACnB;AACA;IACI,cAAc;AAClB;;AAEA,sBAAsB;AACtB;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,iCAAiC;IACjC,sCAAsC;IACtC,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;IAChB,WAAW;IACX,oBAAoB;AACxB;;AAEA,mCAAmC;AACnC;IACI,oBAAoB;IACpB,mBAAmB;IACnB,QAAQ;IACR,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,cAAc;IACd,kBAAkB;AACtB;AACA;IACI,eAAe;AACnB;;;AAGA;IACI,eAAe;IACf,iBAAiB;IACjB,cAAc;IACd,yBAAyB;IACzB,aAAa;IACb,kBAAkB;IAClB,iBAAiB;IACjB,gBAAgB;IAChB,qBAAqB;AACzB;;AAEA;IACI,mBAAmB;IACnB,qBAAqB;IACrB,qBAAqB;IACrB,eAAe;AACnB;;AAEA,2BAA2B;AAC3B;IACI,aAAa;IACb,QAAQ;IACR,eAAe;IACf,gBAAgB;IAChB,yCAAyC;AAC7C;;AAEA;IACI,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,WAAW;IACX,eAAe;IACf,0BAA0B;AAC9B;;AAEA;IACI,WAAW;IACX,+BAA+B;IAC/B,gCAAgC;AACpC;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;;IAEI,0BAA0B;AAC9B;;AAEA;IACI,0BAA0B;AAC9B;;AAEA,2CAA2C;AAC3C;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,0BAA0B;IAC1B,qCAAqC;IACrC,qBAAqB;IACrB,eAAe;IACf,sBAAsB;IACtB,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,WAAW;IACX,oCAAoC;AACxC;;AAEA;IACI,KAAK,WAAW,EAAE;IAClB,MAAM,YAAY,EAAE;IACpB,MAAM,aAAa,EAAE;IACrB,MAAM,cAAc,EAAE;AAC1B;;AAEA;IACI,WAAW,YAAY,EAAE;IACzB,MAAM,UAAU,EAAE;AACtB;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,4BAA4B;IAC5B,2BAA2B;IAC3B,yCAAyC;IACzC,sBAAsB;IACtB,iBAAiB;EACnB;EACA;IACE,WAAW;IACX,qBAAqB;IACrB,kBAAkB;IAClB,MAAM;IACN,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,uCAAuC;IACvC,4BAA4B;EAC9B;EACA;IACE,2BAA2B;IAC3B,gDAAgD;IAChD,mBAAmB;EACrB;EACA;IACE,4BAA4B;IAC5B,+CAA+C;IAC/C,qBAAqB;EACvB;;EAEA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,2BAA2B;IAC7B;EACF;EACA;IACE;MACE,2BAA2B;IAC7B;IACA;MACE,0BAA0B;IAC5B;IACA;MACE,2BAA2B;IAC7B;EACF;EACA;IACE;MACE,4BAA4B;IAC9B;IACA;MACE,2BAA2B;IAC7B;IACA;MACE,4BAA4B;IAC9B;EACF;;AAEF,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,0BAA0B;IAC1B,qBAAqB;AACzB;;AAEA;IACI,WAAW;IACX,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gCAAgC;AACpC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,OAAO;AACX;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,gBAAgB;IAChB,kBAAkB;IAClB,eAAe;IACf,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,gBAAgB;IAChB,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,OAAO;IACP,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;IACf,gBAAgB;IAChB,eAAe;IACf,YAAY;IACZ,0BAA0B;AAC9B;;AAEA;IACI,+BAA+B;IAC/B,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;AACvB;;AAEA,6BAA6B;AAC7B;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,SAAS;IACT,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,6BAA6B;IAC7B,kBAAkB;AACtB;AACA;IACI,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,0BAA0B;AAC9B;AACA;IACI,cAAc;AAClB;;AAEA,4BAA4B;AAC5B;IACI,cAAc;IACd,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,+BAA+B;IAC/B,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,uBAAuB;IACvB,QAAQ;IACR,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,eAAe;IACf,0BAA0B;IAC1B,gBAAgB;AACpB;;AAEA;IACI,iCAAiC;IACjC,iCAAiC;AACrC;;AAEA;IACI,eAAe;IACf,0BAA0B;IAC1B,eAAe;IACf,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,SAAS;IACT,WAAW;IACX,eAAe;IACf,gBAAgB;AACpB;;AAEA,yBAAyB;AACzB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,SAAS;AACb;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;IACnB,aAAa;AACjB;AACA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;AACA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;AACZ;AACA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;AACf;AACA;IACI,sBAAsB;IACtB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,oBAAoB;IACpB,aAAa;AACjB;AACA;IACI,iCAAiC;IACjC,uEAAuE;AAC3E;AACA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA,mBAAmB;AACnB;IACI,iBAAiB;IACjB,SAAS;IACT,mBAAmB;IACnB,6BAA6B;IAC7B,cAAc;IACd,eAAe;IACf,gBAAgB;AACpB;;AAEA;IACI,iBAAiB;AACrB;;AAEA,oBAAoB;AACpB;IACI,yBAAyB;IACzB,WAAW;IACX,aAAa;IACb,eAAe;AACnB;;AAEA;;IAEI,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,yBAAyB;AACzB;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;IAC7B,eAAe;AACnB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,iBAAiB;IACjB,iBAAiB;AACrB;;AAEA,iBAAiB;AACjB;IACI,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,gCAAgC;IAChC,eAAe;AACnB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,WAAW;IACX,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,yBAAyB;IACzB,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,mBAAmB;IACnB,cAAc;AAClB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,iBAAiB;IACjB,6BAA6B;IAC7B,mBAAmB;IACnB,eAAe;IACf,aAAa;IACb,QAAQ;IACR,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA,6BAA6B;AAC7B;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,mBAAmB;IACnB,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,iBAAiB;AACrB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,sBAAsB;IACtB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,gBAAgB;IAChB,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,gBAAgB;IAChB,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,sBAAsB;IACtB,eAAe;IACf,8BAA8B;IAC9B,kBAAkB;AACtB;;AAEA;IACI,gBAAgB;IAChB,WAAW;IACX,sBAAsB;IACtB,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,cAAc;IACd,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,cAAc;IACd,kBAAkB;IAClB,OAAO;AACX;;AAEA;;6CAE6C;;AAE7C,+BAA+B;AAC/B;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,0CAA0C;AAC1C;IACI,mBAAmB;AACvB;;AAEA,gCAAgC;AAChC;IACI,8BAA8B;IAC9B,yBAAyB;IACzB,yBAAyB;AAC7B;;AAEA,4BAA4B;AAC5B;IACI,eAAe;IACf,gBAAgB;IAChB,6BAA6B;AACjC;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,eAAe;IACf,WAAW;AACf;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,mBAAmB;IACnB,cAAc;IACd,cAAc;IACd,gBAAgB;IAChB,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA,sBAAsB;AACtB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;AACtB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iBAAiB;AACrB;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,yBAAyB;IACzB,kBAAkB;IAClB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,iBAAiB;IACjB,eAAe;IACf,eAAe;IACf,gCAAgC;IAChC,SAAS;IACT,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,SAAS;IACT,cAAc;AAClB;;AAEA;IACI,OAAO;IACP,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,eAAe;IACf,iBAAiB;AACrB;;AAEA;IACI,eAAe;IACf,cAAc;IACd,qBAAqB;AACzB;;AAEA;IACI,0BAA0B;AAC9B;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,qBAAqB;AACrB;IACI,iBAAiB;IACjB,yBAAyB;IACzB,kBAAkB;IAClB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;IACnB,WAAW;IACX,iBAAiB;IACjB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,QAAQ;AACZ;;AAEA;IACI,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,WAAW;AACf;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,QAAQ;IACR,cAAc;IACd,WAAW;IACX,eAAe;AACnB;;AAEA;IACI,cAAc;IACd,eAAe;AACnB;;AAEA;IACI,iBAAiB;IACjB,aAAa;IACb,QAAQ;IACR,6BAA6B;AACjC;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,mBAAmB;AACvB;;AAEA,mDAAmD;AACnD;IACI,cAAc;AAClB;;AAEA;IACI,qBAAqB;IACrB,gCAAgC;AACpC","sourcesContent":[".chat-bot{\r\n\tposition: fixed;\r\n    right: 0;\r\n    bottom: 0;\r\n    width: 80px;\r\n    height: 80px;\r\n    background-color: var(--accent-color);\r\n    margin: 20px;\r\n    border-radius: 15px;\r\n    filter: drop-shadow(0px 4px 4px rgba(0, 0, 0, 0.25));\r\n    cursor: pointer;\r\n}\r\n\r\n.dashboard-modal-dialog .dashboard-modal-dialog-titlebar {\r\n    background: var(--accent-color) !important;\r\n    border: none;\r\n    padding: 5px 10px;\r\n}\r\n\r\n.dashboard-modal-dialog .dashboard-modal-dialog-titlebar .ui-dialog-title {\r\n    color: #fff;\r\n    font-size: 13px;\r\n}\r\n\r\n.dashboard-modal-dialog .dashboard-modal-dialog-titlebar .ui-button {\r\n    color: #fff;\r\n}\r\n\r\n.chat-bot-modal-content{\r\n    margin: 0;\r\n    padding: 0 10px 10px 10px !important;\r\n    display: flex;\r\n    flex-direction: column;\r\n    height: 100%;\r\n    box-sizing: border-box;\r\n    overflow: hidden !important;\r\n}\r\n\r\n.ai-chat{\r\n    flex: 1;\r\n    overflow-y: auto;\r\n    overflow-x: hidden;\r\n    margin-top: 10px;\r\n    scroll-behavior: smooth;\r\n    scrollbar-width: thin;\r\n    scrollbar-color: rgba(0,0,0,0.15) transparent;\r\n    position: relative;\r\n    -webkit-user-select: text;\r\n    -moz-user-select: text;\r\n    -ms-user-select: text;\r\n    user-select: text;\r\n}\r\n\r\n.ai-chat::-webkit-scrollbar {\r\n    width: 5px;\r\n}\r\n\r\n.ai-chat::-webkit-scrollbar-track {\r\n    background: transparent;\r\n}\r\n\r\n.ai-chat::-webkit-scrollbar-thumb {\r\n    background: rgba(0,0,0,0.15);\r\n    border-radius: 10px;\r\n}\r\n\r\n.ai-chat::-webkit-scrollbar-thumb:hover {\r\n    background: rgba(0,0,0,0.3);\r\n}\r\n\r\n.search-area{\r\n    flex-shrink: 0;\r\n}\r\n\r\n#messageCounter{\r\n    flex-shrink: 0;\r\n    margin: 10px 10px 0;\r\n    text-align: center;\r\n    font-size: 11px;\r\n}\r\n\r\n.message-box{\r\n    padding: 10px 12px;\r\n    border-radius: 0 6px 6px 6px;\r\n    position: relative;\r\n    background: rgba(171, 207, 57, 0.025);\r\n    border: 2px solid var(--main-secondary);\r\n    color: #2d2d2d;\r\n    font-size: 12px;\r\n    margin: 0;\r\n    box-sizing: border-box;\r\n    word-wrap: break-word;\r\n    overflow-wrap: break-word;\r\n}\r\n\r\n.message-box p{\r\n    margin: 0;\r\n}\r\n\r\n.message-box li{\r\n    margin-left: 16px;\r\n    list-style: disc;\r\n    line-height: 1.6;\r\n}\r\n\r\n.message-box strong{\r\n    font-weight: 600;\r\n}\r\n\r\n.message-box em{\r\n    font-style: italic;\r\n}\r\n\r\n.time{\r\n    font-size: 10px;\r\n    text-align: right;\r\n}\r\n\r\n.ai-response{\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n\r\n  .ask {\r\n    background: rgba(248,155,60,0.02);\r\n    border: var(--accent-color) 2px solid;\r\n    border-radius: 6px 0 6px 6px;\r\n    box-sizing: border-box;\r\n    flex: 1;\r\n    min-width: 0;\r\n  }\r\n  \r\n  \r\n\r\n.ai-response .ai-img{\r\n    flex-shrink: 0;\r\n    margin-top: 4px;\r\n}\r\n\r\n.ai-response-content{\r\n    flex: 1;\r\n    min-width: 0;\r\n}\r\n\r\n.ai-ask{\r\n    display: flex;\r\n    align-items: flex-start;\r\n    flex-direction: row-reverse;\r\n    gap: 8px;\r\n    margin-bottom: 15px;\r\n}\r\n\r\n.user-avatar{\r\n    flex-shrink: 0;\r\n    width: 36px;\r\n    height: 36px;\r\n    border-radius: 50%;\r\n    background: linear-gradient(135deg, var(--accent-color), #e8873a);\r\n    color: #fff;\r\n    font-size: 13px;\r\n    font-weight: 600;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    letter-spacing: 0.5px;\r\n    margin-top: 4px;\r\n    box-shadow: 0 2px 4px rgba(0,0,0,0.15);\r\n}\r\n\r\n/* Styling the input field */\r\n.input-group {\r\n    margin-top: 20px;\r\n    background-color: #fff;\r\n    display: flex;\r\n    flex-direction: column;\r\n    flex-shrink: 0;\r\n}\r\n.ai-form-control {\r\n    border: #ACACAC solid 1px !important;\r\n    border-radius: 7px 7px 0 0 !important;\r\n    border-bottom: none !important;\r\n    display: block;\r\n    min-height: 35px;\r\n    max-height: 120px;\r\n    padding: 0.375rem 0.75rem;\r\n    font-size: 12px !important;\r\n    line-height: 1.5;\r\n    color: #495057;\r\n    background-color: #fff;\r\n    background-clip: padding-box;\r\n    resize: none;\r\n    overflow-y: auto;\r\n    font-family: inherit;\r\n    width: 100%;\r\n    box-sizing: border-box;\r\n}\r\n.input-toolbar {\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: flex-end;\r\n    gap: 4px;\r\n    padding: 4px 8px;\r\n    border: #ACACAC solid 1px;\r\n    border-top: none;\r\n    border-radius: 0 0 7px 7px;\r\n    background: #fafafa;\r\n}\r\n.toolbar-btn {\r\n    font-size: 14px;\r\n    color: #888;\r\n    cursor: pointer;\r\n    padding: 4px 6px;\r\n    border-radius: 4px;\r\n    transition: all 0.15s;\r\n}\r\n.toolbar-btn:hover {\r\n    color: var(--accent-color);\r\n    background: rgba(248,155,60,0.08);\r\n}\r\n\r\n/* File chip */\r\n.ai-file-chip-area {\r\n    flex-shrink: 0;\r\n}\r\n.ai-file-chip {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 5px 10px;\r\n    margin: 6px 0 0;\r\n    background: #f0f4f8;\r\n    border: 1px solid #d0d7de;\r\n    border-radius: 6px;\r\n    font-size: 11px;\r\n    color: #333;\r\n}\r\n.file-chip-name {\r\n    font-weight: 600;\r\n    max-width: 180px;\r\n    overflow: hidden;\r\n    text-overflow: ellipsis;\r\n    white-space: nowrap;\r\n}\r\n.file-chip-size {\r\n    color: #888;\r\n}\r\n.file-chip-remove {\r\n    cursor: pointer;\r\n    color: #888;\r\n    margin-left: auto;\r\n    font-size: 10px;\r\n}\r\n.file-chip-remove:hover {\r\n    color: #d32f2f;\r\n}\r\n\r\n/* Drag-drop overlay */\r\n.ai-drop-overlay {\r\n    position: absolute;\r\n    top: 0;\r\n    left: 0;\r\n    right: 0;\r\n    bottom: 0;\r\n    background: rgba(248,155,60,0.08);\r\n    border: 2px dashed var(--accent-color);\r\n    border-radius: 8px;\r\n    display: flex;\r\n    align-items: center;\r\n    justify-content: center;\r\n    font-size: 13px;\r\n    color: var(--accent-color);\r\n    font-weight: 600;\r\n    z-index: 10;\r\n    pointer-events: none;\r\n}\r\n\r\n/* File indicator in user message */\r\n.ai-file-indicator {\r\n    display: inline-flex;\r\n    align-items: center;\r\n    gap: 4px;\r\n    background: #e8f0fe;\r\n    padding: 2px 8px;\r\n    border-radius: 4px;\r\n    font-size: 10px;\r\n    color: #1a73e8;\r\n    margin-bottom: 4px;\r\n}\r\n.ai-file-indicator .glyphicon {\r\n    font-size: 10px;\r\n}\r\n\r\n\r\n.ai-sources{\r\n    font-size: 10px;\r\n    font-weight: bold;\r\n    margin: 20px 0;\r\n    background-color: #EDEDED;\r\n    padding: 10px;\r\n    border-radius: 6px;\r\n    line-height: 20px;\r\n    overflow: hidden;\r\n    word-break: break-all;\r\n}\r\n\r\n.ai-sources a{\r\n    font-weight: normal;\r\n    word-break: break-all;\r\n    display: inline-block;\r\n    max-width: 100%;\r\n}\r\n\r\n/* Message action buttons */\r\n.msg-actions {\r\n    display: flex;\r\n    gap: 4px;\r\n    margin-top: 8px;\r\n    padding-top: 6px;\r\n    border-top: 1px solid rgba(0, 0, 0, 0.06);\r\n}\r\n\r\n.msg-action-btn {\r\n    background: none;\r\n    border: 1px solid transparent;\r\n    border-radius: 4px;\r\n    padding: 2px 5px;\r\n    cursor: pointer;\r\n    color: #999;\r\n    font-size: 11px;\r\n    transition: all 0.15s ease;\r\n}\r\n\r\n.msg-action-btn:hover {\r\n    color: #555;\r\n    background: rgba(0, 0, 0, 0.05);\r\n    border-color: rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.msg-action-btn.active {\r\n    color: var(--accent-color);\r\n}\r\n\r\n.msg-action-btn.active .glyphicon-thumbs-up,\r\n.msg-action-btn.active .glyphicon-thumbs-down {\r\n    color: var(--accent-color);\r\n}\r\n\r\n.msg-action-btn.active .glyphicon-copy {\r\n    color: var(--main-primary);\r\n}\r\n\r\n/* Status text while searching/generating */\r\n.ai-status-text {\r\n    font-size: 11px;\r\n    color: #888;\r\n    padding: 6px 0;\r\n    font-style: italic;\r\n}\r\n\r\n.ai-status-text .status-icon {\r\n    color: var(--accent-color);\r\n    animation: status-pulse 1.2s infinite;\r\n    display: inline-block;\r\n    font-size: 10px;\r\n    vertical-align: middle;\r\n    margin-right: 4px;\r\n}\r\n\r\n.ai-status-text .status-icon.done {\r\n    animation: none;\r\n    color: #4CAF50;\r\n    font-size: 14px;\r\n}\r\n\r\n.dot-anim::after {\r\n    content: '';\r\n    animation: dot-loading 1.5s infinite;\r\n}\r\n\r\n@keyframes dot-loading {\r\n    0% { content: ''; }\r\n    25% { content: '.'; }\r\n    50% { content: '..'; }\r\n    75% { content: '...'; }\r\n}\r\n\r\n@keyframes status-pulse {\r\n    0%, 100% { opacity: 0.3; }\r\n    50% { opacity: 1; }\r\n}\r\n\r\n.dot-pulse {\r\n    position: relative;\r\n    left: -9999px;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    background-color: var(--main-secondary);\r\n    color: var(--main-secondary);\r\n    box-shadow: 9999px 0 0 -5px;\r\n    animation: dot-pulse 1.5s infinite linear;\r\n    animation-delay: 0.25s;\r\n    margin-left: 95px;\r\n  }\r\n  .dot-pulse::before, .dot-pulse::after {\r\n    content: \"\";\r\n    display: inline-block;\r\n    position: absolute;\r\n    top: 0;\r\n    width: 10px;\r\n    height: 10px;\r\n    border-radius: 5px;\r\n    background-color: var(--main-secondary);\r\n    color: var(--main-secondary);\r\n  }\r\n  .dot-pulse::before {\r\n    box-shadow: 9984px 0 0 -5px;\r\n    animation: dot-pulse-before 1.5s infinite linear;\r\n    animation-delay: 0s;\r\n  }\r\n  .dot-pulse::after {\r\n    box-shadow: 10014px 0 0 -5px;\r\n    animation: dot-pulse-after 1.5s infinite linear;\r\n    animation-delay: 0.5s;\r\n  }\r\n  \r\n  @keyframes dot-pulse-before {\r\n    0% {\r\n      box-shadow: 9984px 0 0 -5px;\r\n    }\r\n    30% {\r\n      box-shadow: 9984px 0 0 2px;\r\n    }\r\n    60%, 100% {\r\n      box-shadow: 9984px 0 0 -5px;\r\n    }\r\n  }\r\n  @keyframes dot-pulse {\r\n    0% {\r\n      box-shadow: 9999px 0 0 -5px;\r\n    }\r\n    30% {\r\n      box-shadow: 9999px 0 0 2px;\r\n    }\r\n    60%, 100% {\r\n      box-shadow: 9999px 0 0 -5px;\r\n    }\r\n  }\r\n  @keyframes dot-pulse-after {\r\n    0% {\r\n      box-shadow: 10014px 0 0 -5px;\r\n    }\r\n    30% {\r\n      box-shadow: 10014px 0 0 2px;\r\n    }\r\n    60%, 100% {\r\n      box-shadow: 10014px 0 0 -5px;\r\n    }\r\n  }\r\n\r\n/* Connection Proposal Card */\r\n.ai-connection-proposal {\r\n    margin: 10px 12px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.proposal-header {\r\n    background: var(--accent-color);\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.proposal-header .proposal-icon {\r\n    font-size: 13px;\r\n}\r\n\r\n.proposal-details {\r\n    padding: 10px 12px 6px;\r\n    font-size: 11px;\r\n    line-height: 1.6;\r\n}\r\n\r\n.proposal-field {\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.proposal-label {\r\n    font-weight: 600;\r\n    color: #555;\r\n}\r\n\r\n.proposal-url {\r\n    color: var(--accent-color);\r\n    word-break: break-all;\r\n}\r\n\r\n.proposal-desc {\r\n    color: #777;\r\n    font-style: italic;\r\n    margin-top: 4px;\r\n}\r\n\r\n.proposal-endpoints {\r\n    padding: 6px 12px 10px;\r\n    font-size: 11px;\r\n}\r\n\r\n.proposal-endpoints-title {\r\n    font-weight: 600;\r\n    color: #555;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.proposal-action-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 3px 0;\r\n    border-bottom: 1px solid #f0f0f0;\r\n}\r\n\r\n.proposal-action-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.proposal-method {\r\n    background: #e8f5e9;\r\n    color: #2e7d32;\r\n    font-size: 9px;\r\n    font-weight: 700;\r\n    padding: 1px 5px;\r\n    border-radius: 3px;\r\n    min-width: 32px;\r\n    text-align: center;\r\n}\r\n\r\n.proposal-operation {\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #333;\r\n    flex: 1;\r\n}\r\n\r\n.proposal-action-type {\r\n    background: #e3f2fd;\r\n    color: #1565c0;\r\n    font-size: 8px;\r\n    font-weight: 700;\r\n    padding: 1px 4px;\r\n    border-radius: 3px;\r\n    min-width: 40px;\r\n    text-align: center;\r\n    letter-spacing: 0.3px;\r\n}\r\n\r\n.proposal-db-type {\r\n    font-weight: 600;\r\n    color: #1565c0;\r\n}\r\n\r\n.proposal-no-actions {\r\n    padding: 8px 0;\r\n    font-size: 11px;\r\n    color: #888;\r\n    font-style: italic;\r\n}\r\n\r\n.proposal-endpoint {\r\n    flex: 1;\r\n    font-family: monospace;\r\n    font-size: 11px;\r\n    color: #333;\r\n}\r\n\r\n.proposal-param-count {\r\n    color: #999;\r\n    font-size: 10px;\r\n    white-space: nowrap;\r\n}\r\n\r\n.proposal-buttons {\r\n    padding: 8px 12px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e0e0e0;\r\n    background: #f5f5f5;\r\n}\r\n\r\n.proposal-btn {\r\n    padding: 6px 14px;\r\n    border-radius: 4px;\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    cursor: pointer;\r\n    border: none;\r\n    transition: all 0.15s ease;\r\n}\r\n\r\n.proposal-btn-create {\r\n    background: var(--accent-color);\r\n    color: #fff;\r\n}\r\n\r\n.proposal-btn-create:hover {\r\n    opacity: 0.9;\r\n}\r\n\r\n.proposal-btn-create:disabled {\r\n    opacity: 0.6;\r\n    cursor: not-allowed;\r\n}\r\n\r\n.proposal-btn-cancel {\r\n    background: #fff;\r\n    color: #666;\r\n    border: 1px solid #ddd;\r\n}\r\n\r\n.proposal-btn-cancel:hover {\r\n    background: #f0f0f0;\r\n}\r\n\r\n/* Connection Fallback Card */\r\n.ai-connection-fallback {\r\n    margin: 10px 0;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.fallback-header {\r\n    background: #607D8B;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.fallback-body {\r\n    padding: 10px 12px;\r\n    font-size: 11px;\r\n    line-height: 1.5;\r\n}\r\n\r\n.fallback-body > p {\r\n    margin: 0 0 10px;\r\n    color: #555;\r\n}\r\n\r\n.fallback-options {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 6px;\r\n}\r\n\r\n.fallback-option {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 10px;\r\n    padding: 8px 10px;\r\n    border: 1px solid #e8e8e8;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    transition: all 0.15s ease;\r\n    background: #fff;\r\n}\r\n\r\n.fallback-option:hover {\r\n    border-color: var(--accent-color);\r\n    background: rgba(248,155,60,0.03);\r\n}\r\n\r\n.fallback-option .glyphicon {\r\n    font-size: 16px;\r\n    color: var(--accent-color);\r\n    margin-top: 2px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.fallback-option strong {\r\n    font-size: 11px;\r\n    color: #333;\r\n    display: block;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.fallback-option p {\r\n    margin: 0;\r\n    color: #888;\r\n    font-size: 10px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.fallback-switch {\r\n    margin-top: 10px;\r\n    padding-top: 8px;\r\n    border-top: 1px solid #e8e8e8;\r\n    text-align: center;\r\n}\r\n.fallback-switch-link {\r\n    font-size: 11px;\r\n    color: var(--accent-color);\r\n    cursor: pointer;\r\n    text-decoration: underline;\r\n}\r\n.fallback-switch-link:hover {\r\n    color: #d47a1a;\r\n}\r\n\r\n/* Connection Type Chooser */\r\n.ai-connection-type-chooser {\r\n    margin: 10px 0;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.type-chooser-header {\r\n    background: var(--accent-color);\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.type-chooser-body {\r\n    padding: 10px 12px;\r\n}\r\n\r\n.connection-type-options {\r\n    display: grid;\r\n    grid-template-columns: 1fr 1fr;\r\n    gap: 6px;\r\n}\r\n\r\n.connection-type-option {\r\n    display: flex;\r\n    align-items: flex-start;\r\n    gap: 8px;\r\n    padding: 8px 10px;\r\n    border: 1px solid #e8e8e8;\r\n    border-radius: 6px;\r\n    cursor: pointer;\r\n    transition: all 0.15s ease;\r\n    background: #fff;\r\n}\r\n\r\n.connection-type-option:hover {\r\n    border-color: var(--accent-color);\r\n    background: rgba(248,155,60,0.03);\r\n}\r\n\r\n.connection-type-option .glyphicon {\r\n    font-size: 14px;\r\n    color: var(--accent-color);\r\n    margin-top: 2px;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.connection-type-option strong {\r\n    font-size: 11px;\r\n    color: #333;\r\n    display: block;\r\n    margin-bottom: 1px;\r\n}\r\n\r\n.connection-type-option p {\r\n    margin: 0;\r\n    color: #888;\r\n    font-size: 10px;\r\n    line-height: 1.3;\r\n}\r\n\r\n/* Test Connection Card */\r\n.ai-test-connection-card {\r\n    margin: 10px 12px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.test-card-header {\r\n    background: #1976D2;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.test-card-body {\r\n    padding: 10px 12px;\r\n    font-size: 11px;\r\n    color: #555;\r\n    line-height: 1.5;\r\n}\r\n\r\n.test-card-body p {\r\n    margin: 0;\r\n}\r\n\r\n.test-card-buttons {\r\n    padding: 8px 12px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e0e0e0;\r\n    background: #f5f5f5;\r\n}\r\n\r\n/* Credential Form */\r\n.ai-credential-form {\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #fafafa;\r\n    margin: 8px 0;\r\n}\r\n.cred-form-header {\r\n    background: #6A1B9A;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n.cred-form-body {\r\n    padding: 10px 12px;\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 8px;\r\n}\r\n.cred-form-field {\r\n    display: flex;\r\n    flex-direction: column;\r\n    gap: 3px;\r\n}\r\n.cred-form-label {\r\n    font-size: 11px;\r\n    font-weight: 600;\r\n    color: #555;\r\n}\r\n.cred-form-input {\r\n    border: 1px solid #ccc;\r\n    border-radius: 4px;\r\n    padding: 6px 8px;\r\n    font-size: 12px;\r\n    font-family: inherit;\r\n    outline: none;\r\n}\r\n.cred-form-input:focus {\r\n    border-color: var(--accent-color);\r\n    box-shadow: 0 0 0 2px rgba(var(--accent-color-rgb, 232, 151, 39), 0.15);\r\n}\r\n.cred-form-buttons {\r\n    padding: 8px 12px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e0e0e0;\r\n    background: #f5f5f5;\r\n}\r\n\r\n/* Update Warning */\r\n.proposal-update-warning {\r\n    padding: 8px 12px;\r\n    margin: 0;\r\n    background: #fff8e1;\r\n    border-top: 1px solid #ffe082;\r\n    color: #e65100;\r\n    font-size: 12px;\r\n    line-height: 1.4;\r\n}\r\n\r\n.proposal-update-warning .glyphicon {\r\n    margin-right: 5px;\r\n}\r\n\r\n/* Markdown Tables */\r\n.ai-md-table {\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n    margin: 8px 0;\r\n    font-size: 12px;\r\n}\r\n\r\n.ai-md-table th,\r\n.ai-md-table td {\r\n    border: 1px solid #ddd;\r\n    padding: 5px 8px;\r\n    text-align: left;\r\n}\r\n\r\n.ai-md-table th {\r\n    background: #f5f5f5;\r\n    font-weight: 600;\r\n}\r\n\r\n.ai-md-table tr:nth-child(even) {\r\n    background: #fafafa;\r\n}\r\n\r\n/* AutoComplete Results */\r\n.ai-autocomplete-results {\r\n    margin-top: 8px;\r\n    padding-top: 8px;\r\n    border-top: 1px solid #e0e0e0;\r\n    font-size: 12px;\r\n}\r\n\r\n.autocomplete-result-row {\r\n    padding: 3px 0;\r\n}\r\n\r\n.autocomplete-result-row.success {\r\n    color: #27ae60;\r\n}\r\n\r\n.autocomplete-result-row.error {\r\n    color: #e74c3c;\r\n}\r\n\r\n.autocomplete-icon {\r\n    font-weight: bold;\r\n    margin-right: 4px;\r\n}\r\n\r\n/* Test Results */\r\n.ai-test-results {\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    overflow: hidden;\r\n    background: #fafafa;\r\n}\r\n\r\n.test-results-header {\r\n    background: #388E3C;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.test-results-body {\r\n    padding: 8px 12px;\r\n}\r\n\r\n.test-result-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 5px 0;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    font-size: 11px;\r\n}\r\n\r\n.test-result-row:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.test-result-icon {\r\n    font-size: 13px;\r\n    width: 18px;\r\n    text-align: center;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.test-passed .test-result-icon {\r\n    color: #2e7d32;\r\n}\r\n\r\n.test-fixed .test-result-icon {\r\n    color: #F57C00;\r\n}\r\n\r\n.test-failed .test-result-icon {\r\n    color: #c62828;\r\n}\r\n\r\n.test-result-name {\r\n    flex: 1;\r\n    color: #333;\r\n    font-weight: 500;\r\n}\r\n\r\n.test-result-status {\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    text-transform: uppercase;\r\n    padding: 1px 6px;\r\n    border-radius: 3px;\r\n}\r\n\r\n.test-passed .test-result-status {\r\n    background: #e8f5e9;\r\n    color: #2e7d32;\r\n}\r\n\r\n.test-fixed .test-result-status {\r\n    background: #FFF3E0;\r\n    color: #E65100;\r\n}\r\n\r\n.test-failed .test-result-status {\r\n    background: #FFEBEE;\r\n    color: #c62828;\r\n}\r\n\r\n.test-fix-details {\r\n    font-size: 10px;\r\n    color: #888;\r\n    font-style: italic;\r\n}\r\n\r\n.test-results-summary {\r\n    padding: 8px 12px;\r\n    border-top: 1px solid #e0e0e0;\r\n    background: #f5f5f5;\r\n    font-size: 11px;\r\n    display: flex;\r\n    gap: 8px;\r\n    align-items: center;\r\n}\r\n\r\n.test-summary-stats {\r\n    font-weight: 600;\r\n    color: #555;\r\n}\r\n\r\n.test-summary-text {\r\n    color: #777;\r\n}\r\n\r\n/* Parameter Reference Card */\r\n.ai-param-reference {\r\n    margin: 10px 12px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.param-ref-header {\r\n    background: #455A64;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.param-ref-body {\r\n    padding: 8px 12px;\r\n}\r\n\r\n.param-ref-action {\r\n    margin-bottom: 10px;\r\n    border-bottom: 1px solid #e8e8e8;\r\n    padding-bottom: 8px;\r\n}\r\n\r\n.param-ref-action:last-child {\r\n    margin-bottom: 0;\r\n    border-bottom: none;\r\n    padding-bottom: 0;\r\n}\r\n\r\n.param-ref-action-header {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    margin-bottom: 6px;\r\n    font-size: 11px;\r\n}\r\n\r\n.param-ref-action-header strong {\r\n    color: #333;\r\n}\r\n\r\n.param-ref-endpoint {\r\n    font-family: monospace;\r\n    font-size: 10px;\r\n    color: #888;\r\n}\r\n\r\n.param-ref-section {\r\n    margin-left: 4px;\r\n    margin-bottom: 4px;\r\n}\r\n\r\n.param-ref-section-title {\r\n    font-size: 10px;\r\n    font-weight: 600;\r\n    color: #777;\r\n    margin-bottom: 2px;\r\n}\r\n\r\n.param-ref-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 2px 0 2px 8px;\r\n    font-size: 10px;\r\n    border-left: 2px solid #e0e0e0;\r\n    margin-bottom: 1px;\r\n}\r\n\r\n.param-ref-name {\r\n    font-weight: 600;\r\n    color: #333;\r\n    font-family: monospace;\r\n    font-size: 10px;\r\n}\r\n\r\n.param-ref-type {\r\n    background: #ECEFF1;\r\n    color: #546E7A;\r\n    font-size: 9px;\r\n    padding: 0 4px;\r\n    border-radius: 2px;\r\n    font-family: monospace;\r\n}\r\n\r\n.param-ref-placement {\r\n    background: #E8EAF6;\r\n    color: #3F51B5;\r\n    font-size: 9px;\r\n    padding: 0 4px;\r\n    border-radius: 2px;\r\n}\r\n\r\n.param-ref-desc {\r\n    color: #999;\r\n    font-size: 9px;\r\n    font-style: italic;\r\n    flex: 1;\r\n}\r\n\r\n/* ========================================\r\n   Vector Database Connection Components\r\n   ======================================== */\r\n\r\n/* Vector DB Credentials Form */\r\n.ai-vectordb-form .cred-form-header.vectordb-header {\r\n    background: #009688;\r\n}\r\n\r\n.ai-vectordb-form .proposal-btn-create {\r\n    background: #009688;\r\n}\r\n\r\n.ai-vectordb-form .proposal-btn-create:hover {\r\n    background: #00796B;\r\n}\r\n\r\n/* Vector DB Proposal Card - teal header */\r\n.ai-connection-proposal .proposal-header:has(.glyphicon-grain) {\r\n    background: #009688;\r\n}\r\n\r\n/* Vector DB action type badge */\r\n.vectordb-action-type {\r\n    background: #E0F2F1 !important;\r\n    color: #00695C !important;\r\n    border: 1px solid #B2DFDB;\r\n}\r\n\r\n/* Linked Apps in Proposal */\r\n.vectordb-linked-apps {\r\n    margin-top: 6px;\r\n    padding-top: 6px;\r\n    border-top: 1px solid #e8e8e8;\r\n}\r\n\r\n.vectordb-linked-app-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 3px 0;\r\n    font-size: 11px;\r\n    color: #333;\r\n}\r\n\r\n.vectordb-linked-app-item .glyphicon {\r\n    color: #009688;\r\n    font-size: 11px;\r\n}\r\n\r\n.vectordb-live-sync-badge {\r\n    background: #E8F5E9;\r\n    color: #2E7D32;\r\n    font-size: 9px;\r\n    padding: 1px 6px;\r\n    border-radius: 3px;\r\n    margin-left: auto;\r\n}\r\n\r\n/* App Selector Card */\r\n.ai-app-selector-card {\r\n    margin: 10px 12px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.app-selector-header {\r\n    background: #009688;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.app-selector-body {\r\n    padding: 10px 12px;\r\n}\r\n\r\n.app-selector-desc {\r\n    font-size: 11px;\r\n    color: #666;\r\n    margin: 0 0 8px 0;\r\n}\r\n\r\n.app-selector-list {\r\n    max-height: 200px;\r\n    overflow-y: auto;\r\n    border: 1px solid #e8e8e8;\r\n    border-radius: 4px;\r\n    background: #fff;\r\n}\r\n\r\n.app-selector-item {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 8px;\r\n    padding: 6px 10px;\r\n    cursor: pointer;\r\n    font-size: 11px;\r\n    border-bottom: 1px solid #f0f0f0;\r\n    margin: 0;\r\n    font-weight: normal;\r\n}\r\n\r\n.app-selector-item:last-child {\r\n    border-bottom: none;\r\n}\r\n\r\n.app-selector-item:hover {\r\n    background: #f5f5f5;\r\n}\r\n\r\n.app-selector-checkbox {\r\n    margin: 0;\r\n    flex-shrink: 0;\r\n}\r\n\r\n.app-selector-name {\r\n    flex: 1;\r\n    color: #333;\r\n}\r\n\r\n.app-selector-count {\r\n    color: #999;\r\n    font-size: 10px;\r\n}\r\n\r\n.app-selector-toggle {\r\n    margin-top: 6px;\r\n    text-align: right;\r\n}\r\n\r\n.app-selector-toggle a {\r\n    font-size: 10px;\r\n    color: #009688;\r\n    text-decoration: none;\r\n}\r\n\r\n.app-selector-toggle a:hover {\r\n    text-decoration: underline;\r\n}\r\n\r\n.app-selector-buttons {\r\n    padding: 8px 12px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e8e8e8;\r\n}\r\n\r\n.app-selector-buttons .proposal-btn-create {\r\n    background: #009688;\r\n}\r\n\r\n.app-selector-buttons .proposal-btn-create:hover {\r\n    background: #00796B;\r\n}\r\n\r\n/* Sync Prompt Card */\r\n.ai-sync-prompt-card {\r\n    margin: 10px 12px;\r\n    border: 1px solid #e0e0e0;\r\n    border-radius: 8px;\r\n    background: #fafafa;\r\n    overflow: hidden;\r\n}\r\n\r\n.sync-prompt-header {\r\n    background: #2E7D32;\r\n    color: #fff;\r\n    padding: 8px 12px;\r\n    font-size: 12px;\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n}\r\n\r\n.sync-prompt-body {\r\n    padding: 10px 12px;\r\n    font-size: 11px;\r\n}\r\n\r\n.sync-prompt-body p {\r\n    margin: 0 0 8px 0;\r\n    color: #555;\r\n}\r\n\r\n.sync-app-row {\r\n    display: flex;\r\n    align-items: center;\r\n    gap: 6px;\r\n    padding: 3px 0;\r\n    color: #333;\r\n    font-size: 11px;\r\n}\r\n\r\n.sync-app-row .glyphicon {\r\n    color: #009688;\r\n    font-size: 11px;\r\n}\r\n\r\n.sync-prompt-buttons {\r\n    padding: 8px 12px;\r\n    display: flex;\r\n    gap: 8px;\r\n    border-top: 1px solid #e8e8e8;\r\n}\r\n\r\n.sync-prompt-buttons .proposal-btn-create {\r\n    background: #009688;\r\n}\r\n\r\n.sync-prompt-buttons .proposal-btn-create:hover {\r\n    background: #00796B;\r\n}\r\n\r\n/* Vector DB type option in chooser - teal accent */\r\n.connection-type-option[data-connection-type=\"vectordb\"] .glyphicon {\r\n    color: #009688;\r\n}\r\n\r\n.connection-type-option[data-connection-type=\"vectordb\"]:hover {\r\n    border-color: #009688;\r\n    background: rgba(0,150,136,0.03);\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
